import type { ActionTree, ActionContext } from 'vuex'
import type { RootState } from '@/store'
import type {
  AdminPanelState,
  SetAccountsTableDataPayload,
  UpdateServiceStatusPayload,
  AdminPanelAccountRow,
} from './types'
import { ADMIN_PANEL_MUTATIONS, ADMIN_PANEL_ACTIONS } from './types'

interface IAdminPanelActions extends ActionTree<AdminPanelState, RootState> {
  [ADMIN_PANEL_ACTIONS.SET_ACCOUNTS_TABLE_DATA](
    context: ActionContext<AdminPanelState, RootState>,
    payload: SetAccountsTableDataPayload
  ): void
  [ADMIN_PANEL_ACTIONS.UPDATE_SERVICE_STATUS](
    context: ActionContext<AdminPanelState, RootState>,
    payload: UpdateServiceStatusPayload
  ): void
}

const actions: IAdminPanelActions = {
  [ADMIN_PANEL_ACTIONS.SET_ACCOUNTS_TABLE_DATA]({ commit }, { accountsData, simpleSubs, loginDates }) {
    const dataToBeCommitted: AdminPanelAccountRow[] = accountsData.map((acct, index) => ({
      email: acct.email,
      username: `${acct.lastName}, ${acct.firstName}`,
      firstName: acct.firstName,
      lastName: acct.lastName,
      accountId: acct.accountID,
      userId: acct.id,
      subscription: simpleSubs[index],
      sapAcctId: acct.sapAccountId,
      lastLogIn: loginDates[index],
    }))
    commit(ADMIN_PANEL_MUTATIONS.UPDATE_ACCOUNTS_TABLE_DATA, dataToBeCommitted)
  },
  [ADMIN_PANEL_ACTIONS.UPDATE_SERVICE_STATUS]({ commit }, payload) {
    commit(ADMIN_PANEL_MUTATIONS.UPDATE_SERVICE_STATUS, payload)
  },
}

export default actions

